import { useEffect, useState } from "react";
import { api } from "../..";
import { useParams } from "react-router-dom";
export default function SessionPaymentCpt() {
  const { session } = useParams(); // This gives you the 'session' parameter
  const [isAlert, setIsalert] = useState(false);
  useEffect(() => {
    const fetchDescription = async () => {
      try {
        const response = await fetch(`${api}/verify-transaction`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ sessionId: session }), // Correct placement
        });

        if (response.ok) {
          const data = await response.json();
          window.location.href = data.data;
          // console.log("DATA FROM fetchDescription>>>>>", data.data);
        } else {
          // alert("wrong session id provided");
          setIsalert(true);
          throw new Error("Failed to fetch data");
        }
      } catch (error) {
        setTimeout(() => {
          window.location.href = "https://google.com";
        }, 3000);
        console.error(error.message);
      }
    };

    fetchDescription();
  });
  return (
    <div className="w-full h-full flex justify-center align-middle items-center">
      {isAlert ? (
        <div>
          <p className="text-xl">Payment Failed moving out </p>
        </div>
      ) : (
        <p className="text-xl">Please wait your payment is being processed</p>
      )}
    </div>
  );
}
